import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchCustomerType = () => {
  return apiClient(ENDPOINTS.CUSTOMERTYPE, { method: "GET" });
};

export const createCustomerType = (CstomerTypeDate) => {
  return apiClient(ENDPOINTS.CUSTOMERTYPE, {
    method: "POST",
    body: CstomerTypeDate,
  });
};

export const deleteCustomerType = async (id) => {
  await apiClient(ENDPOINTS.CUSTOMERTYPE_BY_ID(id), {
    method: "DELETE",
  });
  return id;
};

export const updateCustomerType = (id, data) => {
  return apiClient(ENDPOINTS.CUSTOMERTYPE_BY_ID(id), {
    method: "PUT",
    body: { id, ...data },
  });
};
